import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

interface WhatsAppButtonProps {
  language?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ language }) => {
  const { t } = useTranslation(language);
  
  return (
    <div className="whatsapp-button-container">
      <a 
        href="https://api.whatsapp.com/send?phone=85297100398" 
        target="_blank" 
        className="whatsapp-button"
        rel="noopener noreferrer"
      >
        {t('contactWhatsApp')}
      </a>
    </div>
  );
};

export default WhatsAppButton;
